<template>
  <v-container fluid class="lighten-12 content">
    <v-data-table
              :fixed-header="true"
              :headers="tableorders"
              :items="TableOrders"
              item-key="id"
              hide-default-footer
            >
            </v-data-table>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "Home",

  data: () => ({
    tableorders:[
       {
        text: "Name",
        value: "table.name",
        show: true,
        disabled: true,

        width: "14%",
      },
      {
        text: "Type",
        value: "table.type",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Capacity",
        value: "table.capacity",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    ],

    TableOrders:[],
  }),

  methods: {
      getTableOrders() {
      axios
        .get(
          `hms/dash-board/table-orders`
        )
        .then((resp) => {
          this.TableOrders = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },

  },
  created() {
    this.getTableOrders();
  },
};
</script>
<style scoped>
</style>
